export default {
    'create-financial-file': 'إنشاء ملف مالي',
    'create-backup': 'إنشاء نسخة احتياطية',
    'edit-financial-file': 'تعديل ملف مالي',
    save: 'حفظ',
    cancel: 'إلغاء',

    confirm: 'مُتابعة',
    'browse-content': 'استعراض محتويات',

    'do-you-want-to-change-the-current-financial-file': 'هل تود تغيير الملف المالي الحالي',

    'rotated-to-$': 'مدور إلى  "{financialFile}"',
    rotated: 'مدور',
    locked: 'مقفل',
    unlocked: 'غير مُقفل',

    'the-users-of-the-file-$-and-their-permissions': 'مُستخدمي ملف {financialFile} وصلاحياتهم',

    permissions: {
        title: 'الصلاحيات',
        'no-permissions': 'لم يتم تحديد صلاحيات',
        viewer: 'مُتصفح بيانات',
        accountant: 'مُحاسب',
        'warehouse-keeper': 'أمين مستودع',
        'warehouse-manager': 'مدير مستودع'
    },

    'the-logo-is-uploaded-successfully': 'تم إرفاق اللوغو بنجاح'
}